import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What are the types of cloud services?",
    answer: `<p>The three primary types of cloud computing are public cloud, private cloud, and hybrid cloud. These deployment models encompass four main service categories: infrastructure as a service (IaaS), platform as a service (PaaS), software as a service (SaaS), and serverless computing.</p>`,
  },
  // {
  //   question: "What are the types of cloud computing?",
  //   answer: `<p>Cloud computing is primarily categorized into three types: public cloud, private cloud, and hybrid cloud. These deployment models support four key services: Infrastructure as a Service (IaaS), Platform as a Service (PaaS), Software as a Service (SaaS), and serverless computing.</p>`,
  // },
  {
    question: "What are the benefits of cloud computing?",
    answer: `<ul><li>Faster Time to Market</li><p>Due to the ability to achieve cloud scalability and the ability to provision and deprovision instances, cloud computing fosters development agility and innovations while avoiding the need for hardware and procurement cycles.</p>
    <li>Scalability and Flexibility</li><p>Cloud computing allows organizations to obtain resources and storage credit along with the physical structures that may not be easily altered thus accommodating expanses of business needs at short notice.</p>
    <li>Cost Savings</li><p>Cloud services allow you to avoid overbuilding and over-provisioning because they are billed based on their usage. This also means that IT teams can now concentrate on business-critical tasks more than worrying about settings.</p>
    <li>Better Collaboration</li><p>Availability: The use of cloud storage means that members from different parts of the world can access information anywhere they are without the need for physical access to an employee’s device.</p>
    <li>Advanced Security</li><p>Security is supported by many facets, never needing manual updates, and can be managed from a central point. The best cloud providers hire only excellent talent and implement the best solutions and security models.</p>
     <li>Data Loss Prevention</li><p>Reliability is realized through routine backup and business continuity options whereby data security is preserved from calamities like hardware breakdowns, hacking, or other mishaps by storing it in the cloud.</p>
    </ul>`,
  },
  {
    question: "How Much Will Your Cloud App Project Cost?",
    answer: `<p>A medium-complexity cloud application typically requires 600 to 800 hours of development time. Depending on project requirements, this can extend up to 1200 hours. The estimated cost for developing such an application ranges from $20,000 to $50,000.</p>`,
  },
  {
    question: "How do I choose a cloud app development company?",
    answer: `<p>When selecting a cloud app development company, consider factors such as the provider's reputation and portfolio, experience in your industry, and key specializations. Additionally, evaluate your project requirements and the appropriate engagement model for your needs.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Cloud Application Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
